import { render, staticRenderFns } from "./CreateCauseOfDeath.vue?vue&type=template&id=0c11c0f6"
import script from "./CreateCauseOfDeath.vue?vue&type=script&lang=js"
export * from "./CreateCauseOfDeath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports